import React from "react";
import "../css/Contact.css";
import interior1 from "../assets/about1.jpeg"; // hero background
import formImage from "../assets/about2.jpeg"; // left image for form section
import Topbar from "../components/Topbar";
import Header from "../components/header";
import Footer from "../screen/Footer"; 
import Herolast  from "../screen/herolast";


export default function Contact() {
  return (
    <>
    <Topbar/>
      <Header />
      {/* HERO */}
      <div className="hero-container">
        <div
          className="background-image"
          style={{ backgroundImage: `url(${interior1})` }}
        >
          <div className="background-overlay" />
        </div>

        <div className="content-overlay">
          <div className="content-card">
            <div className="welcome-section">
              <p className="welcome-text">REACH OUT TO US</p>
            </div>

            <h1 className="main-heading">
              We’re Here to Assist You
            </h1>
          </div>
        </div>
      </div>

      {/* CONTACT INFO CARDS (kept) */}
      <section className="contact-info-section">
        <div className="contact-info-container">
          <div className="info-card info-phone">
            <h3>Phone</h3>
            <p className="info-value">7237898275</p>
          </div>

          <div className="info-card info-email">
            <h3>Email</h3>
            <p className="info-value">jayambeacservicesurat@gmail.com</p>
          </div>

   

          
        </div>
      </section>

      {/* IMAGE + FORM SECTION (new, centered) */}
      <section className="contact-form-section">
        <div className="contact-form-container">
          <div className="contact-form-card">
            <div className="form-image-wrap" aria-hidden>
              <img className="form-image" src={formImage} alt="AC service" />
            </div>

            <div className="form-wrap">
              <form className="contact-form" onSubmit={(e) => e.preventDefault()}>
                <input type="text" name="name" placeholder="Name" className="form-input" />
                <input type="email" name="email" placeholder="Email" className="form-input" />

                <div className="phone-row">
                  <select className="country-select" aria-label="country">
                    <option value="+91">IN +91</option>
                    <option value="+1">US +1</option>
                  </select>
                  <input type="tel" name="phone" placeholder="Phone" className="form-input phone-input" />
                </div>

                <select className="form-select">
                  <option>Locality of service</option>
                  <option>Abhva</option>
                  <option>Adajan</option>
                  <option>Anand Nagar</option>
                </select>

                <select className="form-select">
                  <option>Which air conditioner do you have?</option>
                  <option>Split AC</option>
                  <option>Window AC</option>
                  <option>Cassette AC</option>
                </select>

                <select className="form-select">
                  <option>What issues are you facing?</option>
                  <option>Installation</option>
                  <option>Gas Filling</option>
                  <option>Pipe Leakage</option>
                  <option>Servicing - Normal</option>
                </select>

                <div className="submit-row">
                  <button type="submit" className="submit-btn">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      <Herolast  />
            <Footer  />
    </>
  );
}
